<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row bg-warning pt-3 pb-2">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div class="row mb-2">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
        <h4><span i18n="@@removalRequestMade">Removal request made on</span> {{formatDate(data?.dateOrder)}}
          ({{data?.id}})</h4>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-2"><strong i18n="@@name">Name</strong>:</div>
      <div class="col-8 col-sm-8 col-md-9 col-lg-10 col-xl-10">{{data?.rpName}}</div>
    </div>

    <div class="row mb-1">
      <div class="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-2"><strong i18n="@@address">Address</strong>:</div>
      <div class="col-8 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        {{data?.rpAddress}} {{data?.rpAddress2}}<br>{{data?.rpZip}} - {{data?.rpTownship}}
      </div>
    </div>

    <div class="row mb-1" *ngIf="data?.comments">
      <div class="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-2"><strong i18n="@@comments">Comments</strong>:</div>
      <div class="col-8 col-sm-8 col-md-9 col-lg-10 col-xl-10">{{data?.comments}}</div>
    </div>

    <div class="row mt-2">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-table-pending-animals [data]="animals"></app-table-pending-animals>
      </div>
    </div>
  </div>
</div>
